import * as React from 'react'

const MenuIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={16} fill="none" {...props}>
    <path
      fill="#3A3A88"
      fillRule="evenodd"
      d="M.6 2A1.2 1.2 0 0 1 1.8.8h14.4a1.2 1.2 0 0 1 0 2.4H1.8A1.2 1.2 0 0 1 .6 2Zm0 6a1.2 1.2 0 0 1 1.2-1.2H9a1.2 1.2 0 0 1 0 2.4H1.8A1.2 1.2 0 0 1 .6 8Zm0 6a1.2 1.2 0 0 1 1.2-1.2h14.4a1.2 1.2 0 1 1 0 2.4H1.8A1.2 1.2 0 0 1 .6 14Z"
      clipRule="evenodd"
    />
  </svg>
)
export default MenuIcon
